const entities = require("./enums/entityTypes.json");
const statuses = require("./enums/statuses.json");
const sources = require("./enums/reviewSources.json");
const ratings = require("./enums/ratings.json");
const roles = require("./enums/roles.json");
const locales = require("./enums/locales.json");
const brands = require("./enums/brands.json");
const brandCodes = require("./enums/brandCodes.json");
const country = require("./enums/countryList.json");
const language = require("./enums/languageList.json");
const noContributor = require("./enums/noContributor.json");
const carelinesModeration = require("./enums/carelinesModeration.json");
const anonymousNickname = require("./enums/anonymousNickname.json");
const legalConfig = require("./enums/legalConfig.json");
const profanityCheck = require("./enums/profanityCheck.json");
const brandAliases = require("./enums/brandAliases.json");
const questionCarelinesModeration = require("./enums/questionCarelinesModeration.json");
const statusesQuestion = require("./enums/statusesQuestion.json");
const socialShareCheck = require("./enums/socialShareFeature.json");
const filterTypes = require("./enums/filterTypes.json");
const questionSources = require("./enums/questionSources.json");
const bvExportStatus = require("./enums/bvExportStatus.json");
const brandBusinessGroup = require("./enums/brandBusinessGroup.json");
const reviewMediaSources = require("./enums/reviewMediaSources.json");
const questionMediaSources = require("./enums/questionMediaSources.json");



exports.enums = {
  entityTypes: entities.enum,
  statuses: statuses.enum,
  sources: sources.enum,
  ratings: ratings.enum,
  roles: roles.enum,
  locales: locales.enum,
  brands: brands.enum,
  language: language,
  country: country,
  brandCodes: brandCodes,
  noContributor: noContributor.locales,
  carelinesModeration: carelinesModeration,
  anonymousNickname: anonymousNickname,
  legalConfig: legalConfig,
  profanityCheck: profanityCheck,
  brandAliases: brandAliases,
  questionCarelinesModeration: questionCarelinesModeration,
  statusesQuestion: statusesQuestion,
  socialShareCheck: socialShareCheck,
  filterTypes: filterTypes.enum,
  questionSources: questionSources.enum,
  bvExportStatus: bvExportStatus.enum,
  brandBusinessGroup: brandBusinessGroup,
  reviewMediaSources: reviewMediaSources.enum,
  questionMediaSources: questionMediaSources.enum
};
